<template>
    <v-container fluid>
        <v-row class="d-flex justify-space-between">
            <v-col cols="4" class="text-left">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
            <v-col cols="4"></v-col>
            <v-col cols="4" class="text-right d-flex align-top justify-end">
                <v-checkbox class="d-inline mr-3 mt-1" v-model="selectAll" :label="$t('labels.selectAll')"></v-checkbox>
                <v-btn class="d-inline" color="primary" @click="copyCheckedEmailsToClipboard">
                    <v-icon small>fa-copy</v-icon>&nbsp;&nbsp;{{ $t('buttons.copyMails') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="12" class="pt-0">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="applicationsTable.additionalFilters"
                                    :default-sort="applicationsTable.defaultSort"
                                    :excel="true"
                                    :fields="applicationsTable.headers"
                                    :header-selection-key="'applications-headerss'"
                                    :height="applicationsTable.height"
                                    :total-records="applicationsTable.total"
                                    :filter-save-key="'applications-filterss'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in applicationsTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(item.id, true)"
                                    >
                                        <td>
                                            <v-simple-checkbox :ripple="false" v-model="item.checked">
                                            </v-simple-checkbox>
                                        </td>
                                        <td
                                            v-if="applicationsTable.selectedHeaders.includes('id')"
                                            class="text-right"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.id }}
                                        </td>
                                        <td
                                            v-if="applicationsTable.selectedHeaders.includes('status_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-chip
                                                v-if="item.application_status_id == 1"
                                                class="text-uppercase pl-4"
                                                text-color="#6F6F6F"
                                                color="#6F6F6F40"
                                                ><v-icon x-small left color="#6F6F6F"> fas fa-circle </v-icon
                                                >{{ item.application_status_display }}</v-chip
                                            >
                                            <v-chip
                                                v-if="item.application_status_id == 2"
                                                class="text-uppercase pl-4"
                                                text-color="#BBBB00"
                                                color="#E1E10040"
                                                ><v-icon x-small left color="#BBBB00"> fas fa-circle </v-icon
                                                >{{ item.application_status_display }}</v-chip
                                            >
                                            <v-chip
                                                v-if="item.application_status_id == 3"
                                                class="text-uppercase pl-4"
                                                text-color="#4360DF"
                                                color="#4360DF40"
                                                ><v-icon x-small left color="#4360DF"> fas fa-circle </v-icon
                                                >{{ item.application_status_display }}</v-chip
                                            >
                                            <v-chip
                                                v-if="item.application_status_id == 4"
                                                class="text-uppercase pl-4"
                                                text-color="#FF0000"
                                                color="#FF000040"
                                                ><v-icon x-small left color="#FF0000"> fas fa-circle </v-icon
                                                >{{ item.application_status_display }}</v-chip
                                            >
                                            <v-chip
                                                v-if="item.application_status_id == 5"
                                                class="text-uppercase pl-4"
                                                text-color="#008000"
                                                color="#00800040"
                                                ><v-icon x-small left color="#008000"> fas fa-circle </v-icon
                                                >{{ item.application_status_display }}</v-chip
                                            >
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="applicationsTable.selectedHeaders.includes('vacancy_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.vacancy_display }}
                                        </td>
                                        <td
                                            class="text-center"
                                            v-if="applicationsTable.selectedHeaders.includes('existing_seafarer')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-icon v-if="item.existing_seafarer" small>fa-check</v-icon>
                                            <v-icon v-else small>fa-minus</v-icon>
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="applicationsTable.selectedHeaders.includes('name')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.name }}
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="applicationsTable.selectedHeaders.includes('surname')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.surname }}
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="applicationsTable.selectedHeaders.includes('nationality_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.nationality_display }}
                                        </td>
                                        <td
                                            v-if="applicationsTable.selectedHeaders.includes('email')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.email }}
                                        </td>
                                        <td
                                            v-if="applicationsTable.selectedHeaders.includes('rank_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.rank_display }}
                                        </td>
                                        <td
                                            v-if="applicationsTable.selectedHeaders.includes('vessel_types_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.vessel_types_display }}
                                        </td>
                                        <td
                                            v-if="applicationsTable.selectedHeaders.includes('created_at')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.created_at_display }}
                                        </td>
                                        <td class="text-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'Entities',
    components: {TheTable},
    data: function () {
        return {
            applicationsTable: {
                selectedHeaders: [],
                headers: [
                    {text: '', value: 'checkbox', type: '', sortable: false, width: '30px', allowFilter: false},
                    {text: this.$t('fields.id'), value: 'id', type: 'string', allowFilter: true, width: '50px'},
                    {
                        text: this.$t('fields.status'),
                        value: 'status_id',
                        type: 'multiple|application-statuses',
                        width: '150px',
                    },
                    {
                        text: this.$t('fields.jobTitle'),
                        value: 'vacancy_id',
                        type: 'multiple|vacancies',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.existingSeafarer'),
                        value: 'existing_seafarer',
                        type: 'boolean',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true},
                    {text: this.$t('fields.surname'), value: 'surname', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.nationality'),
                        value: 'nationality_id',
                        type: 'multiple|nationalities',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.email'), value: 'email', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.rank'),
                        value: 'rank_id',
                        type: 'multiple|ranks-abbreviation',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.vesselExpirience'),
                        value: 'vessel_types_id',
                        type: 'multiple|vessel-types',
                        allowFilter: true,
                        sortable: false,
                    },
                    {text: this.$t('fields.dateCreated'), value: 'created_at', type: ''},
                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [{text: this.$t('fields.dateCreated'), value: 'created_at', type: 'date_range'}],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'id',
                    descending: true,
                },
            },
            selectAll: false,
            initialLoad: false,
        };
    },
    watch: {
        selectAll(newVal) {
            if (this.initialLoad) {
                if (newVal) {
                    this.applicationsTable.items.forEach((row) => {
                        row.checked = true;
                    });
                } else {
                    this.applicationsTable.items.forEach((row) => {
                        row.checked = false;
                    });
                }
            }
        },
    },
    methods: {
        addClick() {
            this.$router.push('/applications/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/applications/' + id);
            } else {
                let routeData = this.$router.resolve('/applications/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.applicationsTable.selectedHeaders = headers;
        },
        copyCheckedEmailsToClipboard() {
            let rows = this.applicationsTable.items;
            let emailString = '';

            rows.forEach((row) => {
                if (row.checked === true) {
                    emailString += row.email + ';';
                }
            });

            this.copyToClipboard(emailString);
        },

        copyToClipboard(text) {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    this.$notify(this.$t('alerts.mailsSavedToClipboard'));
                })
                .catch(() => {
                    this.$notify(this.$t('alerts.failedToSaveMails'));
                });
        },

        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'applications', request, (data, success) => {
                if (success) {
                    vm.applicationsTable.items = data.items;
                    vm.applicationsTable.total = data.total;
                    vm.initialLoad = true;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'applications',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/applications', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.applicationsTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.applications'), href: '/#/applications', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resolveWindowResize);
    },
};
</script>

<style scoped></style>
